export const Colors = {
  BLUE_VTOPIA: '#3C7CFF',
  TEXT_PRIMARY: '#3c7cff',
  GREY: '#ced4da',
  LIGHT_GREY: '#8898AA',
  DARK_BLUE: '#172B4D',
};

export default Colors;
